import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0-6a2 2 0 100-4 2 2 0 000 4z" }));
export default createSvgIcon(iconPath, "Archived");
//# sourceMappingURL=StatusArchivedIcon.js.map